module.exports = __webpack_public_path__ + "img/5-7surplus.50e19700.png";